<template>
    <div>
      <vs-popup title="جزئیات سفارش" :active.sync="popupDetailActive" id="trade-history-detail">
        <div class="text-center text-6xl" v-if="trade">
          <div class="flex items-center mx-auto">
            <div class="pr-2 ml-auto quoteAsset">
              <i class="cf" v-if="isFontExist(trade.quoteSymbol)" :class="'cf-'+ trade.quoteSymbol.toLowerCase()" :style="{color:colorSymbol(trade.quoteSymbol)}"></i>
              <img :src="publicPath+'images/currency/' + iconSymbol(trade.quoteSymbol)" width="50px" height="50px" v-else/>
            </div>
            <div class="pr-2 mr-auto baseAsset">
              <i class="cf" v-if="isFontExist(trade.baseSymbol)" :class="'cf-'+ trade.baseSymbol.toLowerCase()" :style="{color:colorSymbol(trade.baseSymbol)}"></i>
              <img :src="publicPath+'images/currency/' + iconSymbol(trade.baseSymbol)" width="50px" height="50px" v-else/>
            </div>
          </div>
        </div>
        <vs-divider v-if="!isLoading && trade">{{$t(trade.model)}} ({{trade.model}})</vs-divider>

        <div class="vx-row">
          <div class="vx-col lg:w-1/2 w-full flex mb-3">
            <div class="vx-col mr-2 font-semibold">
              شناسه سفارش:
            </div>
            <div class="vx-col text-primary">
              <span v-if="!isLoading && trade">#{{trade.id}}</span>
            </div>
          </div>
          <div class="vx-col lg:w-1/2 w-full flex mb-3">
            <div class="vx-col mr-2 font-semibold">
              وضعیت:
            </div>
            <div class="vx-col">
              <span v-if="!isLoading && trade">
                <vs-chip v-if="trade.status == 'success'" color="success" class="mb-0">{{$t(trade.status)}}</vs-chip>
                <vs-chip v-else-if="trade.status == 'canceled'" color="dark" class="mb-0">{{$t(trade.status)}}</vs-chip>
                <vs-chip v-else-if="trade.status == 'return'" color="danger" class="mb-0">{{$t(trade.status)}}</vs-chip>
                <vs-chip v-else-if="trade.status == 'open'" color="warning" class="mb-0">{{$t(trade.status)}}</vs-chip>
                <vs-chip v-else-if="trade.status == 'partial'" color="warning" class="mb-0">{{$t(trade.status)}}</vs-chip>
              </span>
            </div>
          </div>
          <div class="vx-col lg:w-1/2 w-full flex mb-3">
            <div class="vx-col mr-2 font-semibold">
              تاریخ سفارش:
            </div>
            <div class="vx-col vazir">
              <span v-if="!isLoading && trade">{{trade.dateTime}}</span>
            </div>
          </div>
          <div class="vx-col lg:w-1/2 w-full flex mb-3">
            <div class="vx-col mr-2 font-semibold">
              بازار:
            </div>
            <div class="vx-col">
              <span v-if="!isLoading && trade"> {{trade.marketName}} ({{trade.marketSymbol}})</span>
            </div>
          </div>
          <div class="vx-col lg:w-1/2 w-full flex mb-3">
            <div class="vx-col mr-2 font-semibold">
              نوع:
            </div>
            <div class="vx-col ml-2">
               <span v-if="!isLoading && trade" class="flex items-center">
                <div class="h-3 w-3 rounded-full mr-1" :class="'bg-' + (trade.type == 'buy'? 'success' : 'danger' )"></div>
                {{$t(trade.type)}}
              </span>
            </div>
          </div>
          <div class="vx-col lg:w-1/2 w-full flex mb-3">
            <div class="vx-col mr-2 font-semibold">
              مقدار:
            </div>
            <div class="vx-col">
              <span v-if="!isLoading && trade"> {{toFixFloat(trade.amount_base)}} {{trade.baseSymbol}}</span>
            </div>
          </div>
          <div class="vx-col lg:w-1/2 w-full flex mb-3">
            <div class="vx-col mr-2 font-semibold">
              قیمت هر واحد:
            </div>
            <div class="vx-col">
              <span v-if="!isLoading && trade">
                <small v-if="trade.model == 'market'">{{$t('average')}}</small>
                {{toFixFloat(trade.fee)}} <small>{{$t(trade.quoteSymbol)}}</small>
              </span>
            </div>
          </div>
          <div class="vx-col lg:w-1/2 w-full flex mb-3" v-if="!isLoading && trade && trade.stop">
            <div class="vx-col mr-2 font-semibold">
              توقف(stop):
            </div>
            <div class="vx-col">
              <span v-if="!isLoading && trade">
                {{toFixFloat(trade.stop)}} <small>{{$t(trade.quoteSymbol)}}</small>
              </span>
            </div>
          </div>
          <div class="vx-col lg:w-1/2 w-full flex mb-3">
            <div class="vx-col mr-2 font-semibold">
              کارمزد:
            </div>
            <div class="vx-col">
              <span v-if="!isLoading && trade">
                {{'%' + trade.wage}} {{$t('equivalent')}} {{toFixFloat(trade.wage_amount)}}
                {{trade.type == 'buy' ? (trade.baseSymbol) : (trade.quoteSymbol)}}
              </span>
            </div>
          </div>
          <div class="vx-col lg:w-1/2 w-full flex mb-3">
            <div class="vx-col mr-2 font-semibold">
              پرداختی:
            </div>
            <div class="vx-col">
              <span v-if="!isLoading && trade">
                {{trade.type != 'buy' ? toFixFloat(trade.amount_base) : toFixFloat(trade.amount_quote)}}
                {{trade.type != 'buy' ? trade.baseSymbol : trade.quoteSymbol}}
              </span>
            </div>
          </div>
          <div class="vx-col lg:w-1/2 w-full flex mb-3">
            <div class="vx-col mr-2 font-semibold">
              دریافتی:
            </div>
            <div class="vx-col">
              <span v-if="!isLoading && trade">
                {{trade.type == 'buy' ? toFixFloat(trade.amount_base) : toFixFloat(trade.amount_quote)}}
                {{trade.type == 'buy' ? trade.baseSymbol : trade.quoteSymbol}}
              </span>
            </div>
          </div>
          <div class="vx-col lg:w-1/2 w-full flex mb-3">
            <div class="vx-col mr-2 font-semibold">
              خالص دریافتی:
            </div>
            <div class="vx-col">
              <span v-if="!isLoading && trade">
                {{trade.type == 'buy' ? toFixFloat(trade.amount_base - trade.wage_amount) : toFixFloat(trade.amount_quote - trade.wage_amount)}}
                {{trade.type == 'buy' ? (trade.baseSymbol) : (trade.quoteSymbol)}}
              </span>
            </div>
          </div>

          <div class="vx-col w-full mb-3" v-if="trade.status =='partial'">
            <vs-alert color="warning">
              مقدار اولیه این سفارش {{trade.first_amount_base+trade.baseSymbol}} بوده است که
              {{Math.abs(((trade.first_amount_base - trade.amount_base) / trade.first_amount_base *100)-100).toFixed(2)+'%'}}
              آن معادل {{toFixFloat(trade.amount_base)+trade.baseSymbol}} آن انجام شده است.
            </vs-alert>
          </div>


          <vs-divider v-if="fills.length>0"/>
          <div class="vx-col w-full mb-3" v-if="fills.length>0">
            <h5 class="mb-2">
              معاملات این سفارش:
              <br>
              <small>
                هر سفارش ممکن است طی چند معامله انجام شود که در جدول زیر قابل مشاهده است.
              </small>
            </h5>

            <vs-table :data="fills" stripe :noDataText="$t('No data Available')">
              <template slot="thead">
                <vs-th class="border border-solid d-theme-border-grey-light">شناسه</vs-th>
                <vs-th class="border border-solid d-theme-border-grey-light">زمان</vs-th>
                <vs-th class="border border-solid d-theme-border-grey-light">مقدار</vs-th>
                <vs-th class="border border-solid d-theme-border-grey-light">قیمت واحد</vs-th>
              </template>

              <template slot-scope="{data}" v-if="!isLoading && fills">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data" class="text-sm">
                  <vs-td :data="data[indextr].id" class="whitespace-no-wrap">
                    #{{ data[indextr].id }}
                  </vs-td>
                  <vs-td :data="data[indextr].dateTime" class="whitespace-no-wrap vazir">
                    {{ data[indextr].dateTime }}
                  </vs-td>
                  <vs-td :data="data[indextr].amount" class="whitespace-no-wrap">
                    {{ toFixFloat(data[indextr].amount) }} {{trade.baseSymbol}}
                  </vs-td>
                  <vs-td :data="data[indextr].fee" class="whitespace-no-wrap">
                    {{ toFixFloat(data[indextr].fee) }} {{$t(trade.quoteSymbol)}}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>

          <div class="vx-col w-full" v-if="!isLoading && trade && trade.status == 'open'">
            <vs-button @click="removeTrade(trade.id)" color="danger" class="mx-auto py-2" icon-pack="feather" icon="icon-trash"
                     :id="'btn-remove-trade-'+trade.id">{{$t('cancell')}}</vs-button>
          </div>

        </div>
      </vs-popup>
    </div>
</template>
<i18n locale="fa">
{
  "average": "میانگین",
  "limit": "محدود",
  "stop-limit": "حد توقف",
  "oco": "ترکیبی",
  "market": "سریع"
}
</i18n>
<script>
import axios from "../../../../axios";

export default {
  name: 'Detail',
  props: {
    popupDetail: {
      type: Boolean,
      required: true
    },
    idOrder:{
      required: true
    }
  },
  data () {
    return {
      popupDetailActive: this.popupDetail,
      isLoading: false,
      trade: null,
      fills: []
    }
  },
  methods:{
    getData(){
      const self = this;
      axios.post('/history/trades/'+ this.idOrder)
        .then(function (response) {
          self.trade = response.data.trade
          self.fills = response.data.fills
          self.isLoading = false;
        }).catch(function (error) { console.log(error); self.isLoading = false;})
    },
    removeTrade(id){
      this.$emit('removeTrade',id);
    }
  },
  watch: {
    popupDetail (newVal, oldVal) { // watch it
      this.popupDetailActive = newVal
      this.$emit('popupDetailChange', newVal)
    },
    popupDetailActive (newVal, oldVal) { // watch it
      this.popupDetailActive = newVal
      this.$emit('popupDetailChange', newVal)
    },
    isLoading(value){
      if(value){
        this.$vs.loading({
          container: '#trade-history-detail',
          type: 'radius',
          scale: 1.65
        })
      }else
        this.$vs.loading.close('#trade-history-detail > .con-vs-loading')
    }
  },
  created() {
    this.isLoading = true;
    this.getData();
  }
}
</script>

<style lang="scss">
  #trade-history-detail{
    .vx-row .vx-col.w-full.flex {
      padding-bottom: 6px;
      padding-top: 6px;
    }

    @media (max-width: 768px) {
      .vx-row .vx-col.w-full.flex:nth-of-type(odd) {
        background-color: #182a3a !important;
        padding-bottom: 10px !important;
        padding-top: 10px !important;
      }
      .vx-row .vx-col.w-full.flex:nth-of-type(even) {
        padding-bottom: 0px !important;
        padding-top: 0px !important;
      }
    }


    .quoteAsset i,.baseAsset i{
      font-size: 55px;
    }

    .quoteAsset{
        opacity: 0.5;
        margin-right: -18px;
        z-index: 0;
      }
    .baseAsset{
      z-index: 1;
    }
  }
</style>
